module.exports = __webpack_public_path__ + "static/me-a8af26f65f64f65d69f3d60e2224c583.jpg";